module.exports = __webpack_public_path__ + "img/icon-media-document.af2950e8.png";